(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mj-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('mj-save-piece')) return;
  const key = 'maison-jaspers-wishlist-v1';
  let items = [];
  let storageFailed = false;
  let opener = null;
  const config = () => document.querySelector('[data-wishlist-config]')?.dataset || {};
  const safeUrl = (value, image = false) => {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const u = new URL(value, location.origin);
      if (u.protocol !== 'https:') return '';
      if (image) return u.origin === location.origin || u.hostname === 'cdn.shopify.com' ? u.href : '';
      return u.origin === location.origin && /\/products\//.test(u.pathname) ? u.pathname : '';
    } catch { return ''; }
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      const seen = new Set();
      items = (Array.isArray(value) ? value : []).filter(p => {
        if (!p || !/^\d+$/.test(p.id) || typeof p.title !== 'string' || !safeUrl(p.url) || seen.has(p.id)) return false;
        seen.add(p.id); return true;
      }).map(p => ({id:String(p.id),title:p.title.slice(0,500),url:safeUrl(p.url),image:safeUrl(p.image,true)}));
    } catch { storageFailed = true; }
  };
  read();
  const save = () => {
    try { localStorage.setItem(key,JSON.stringify(items)); storageFailed = false; }
    catch { storageFailed = true; }
  };
  const status = text => { const e=document.querySelector('[data-wishlist-status]'); if(e) e.textContent=text; };
  const syncButton = host => {
    const b=host.querySelector('button'); if(!b) return;
    const saved=items.some(p=>p.id===host.dataset.id), t=config();
    b.hidden=false; b.setAttribute('aria-pressed',String(saved));
    b.setAttribute('aria-label',`${saved?t.remove:t.save}: ${host.dataset.title}`);
    const label=b.querySelector('[data-save-label]');if(label)label.textContent=saved?t.saved:t.save;
  };
  const sync = () => {
    document.querySelectorAll('mj-save-piece').forEach(syncButton);
    document.querySelectorAll('[data-wishlist-open]').forEach(b=>b.hidden=false);
    document.querySelectorAll('[data-wishlist-count]').forEach(e=>{e.textContent=String(items.length);e.hidden=!items.length;});
    const warning=document.querySelector('[data-wishlist-storage]');if(warning)warning.hidden=!storageFailed;
  };
  const render = () => {
    const list=document.querySelector('[data-wishlist-list]');if(!list)return;
    const t=config();list.replaceChildren();
    document.querySelector('[data-wishlist-empty]').hidden=items.length>0;
    for(const p of items){
      const li=document.createElement('li');li.className='mj-wishlist-item';
      const media=document.createElement('a');media.href=safeUrl(p.url);media.tabIndex=-1;media.setAttribute('aria-hidden','true');
      if(safeUrl(p.image,true)){const img=document.createElement('img');img.src=safeUrl(p.image,true);img.alt='';img.loading='lazy';media.append(img);}
      const details=document.createElement('div'),h=document.createElement('h3'),a=document.createElement('a');a.href=safeUrl(p.url);a.textContent=p.title;h.append(a);
      const actions=document.createElement('div');actions.className='mj-wishlist-actions';
      const view=document.createElement('a');view.href=safeUrl(p.url);view.textContent=t.view;
      const remove=document.createElement('button');remove.type='button';remove.dataset.wishlistRemove=p.id;remove.textContent=t.remove;remove.setAttribute('aria-label',`${t.remove}: ${p.title}`);
      actions.append(view,remove);details.append(h,actions);li.append(media,details);list.append(li);
    }
    sync();
  };
  const dialog = () => document.getElementById('mj-wishlist-dialog');
  const close = () => {dialog()?.close();opener?.focus();};
  document.addEventListener('click',e=>{
    const open=e.target.closest('[data-wishlist-open]');
    if(open){opener=open;render();const d=dialog();if(d&&!d.open){d.showModal();d.querySelector('[data-wishlist-close]').focus();}return;}
    if(e.target.closest('[data-wishlist-close]')){close();return;}
    if(e.target===dialog()){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();return;}
    const remove=e.target.closest('[data-wishlist-remove]');
    if(remove){const id=remove.dataset.wishlistRemove,index=items.findIndex(p=>p.id===id);items=items.filter(p=>p.id!==id);save();render();status(config().removed);const buttons=document.querySelectorAll('[data-wishlist-remove]');(buttons[Math.min(index,buttons.length-1)]||dialog().querySelector('[data-wishlist-close]')).focus();return;}
    const b=e.target.closest('mj-save-piece button');if(!b)return;
    e.preventDefault();e.stopPropagation();const p=b.closest('mj-save-piece').dataset;
    const exists=items.some(x=>x.id===p.id);
    if(exists)items=items.filter(x=>x.id!==p.id);
    else if(safeUrl(p.url))items.push({id:p.id,title:p.title,url:safeUrl(p.url),image:safeUrl(p.image,true)});
    save();sync();status(exists?config().removed:config().saved);
  });
  document.addEventListener('close',e=>{if(e.target===dialog())opener?.focus();},true);
  window.addEventListener('storage',e=>{if(e.key===key||e.key===null){read();sync();if(dialog()?.open)render();}});
  window.addEventListener('pageshow',()=>{read();sync();});
  document.addEventListener('shopify:section:load',sync);
  customElements.define('mj-save-piece',class extends HTMLElement{connectedCallback(){syncButton(this);}});
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
